module.exports = __webpack_public_path__ + "static/img/official_bg.2ee7d44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/official_bg.png
// module id = N1VY
// module chunks = 6